import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Nav from '../../components/Nav';
import { PageContainer, Body } from '../../components/Layout';
import Users from '../../containers/Users';
// import UsersStats from '../../containers/Users/usersStats';
import { mediaQueries } from '../../constants/breakpoints';
import { getAccountData, getCurrentLevel } from '../../security';
import { Navigate } from 'react-router-dom';
import { store } from '../../modules/storage';
import Header from '../../components/Header';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryHandler, ErrorBoundaryFallback } from '../../components/ErrorBoundary';
import { useUsersQuery } from '../../api/userAPI';

const UserManagementContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: auto;
  max-width: 100%;
  overflow-y: auto;
  @media ${mediaQueries.desktop} {
    height: calc(100% - 30px);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    margin: 15px;
    border-radius: 15px;
  }
`;

const UserManagement = () => {
  const [, setWidth] = useState(window.innerWidth);
  const [, setCurrentUser] = useState();
  const [viewsLevel, setViewsLevel] = useState(-1);

  const {data: usersData} = useUsersQuery(true);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    getAccountData((response) => {
      setCurrentUser(response);
      const currentLevel = getCurrentLevel(response);
      store.number('viewsLevel', currentLevel);
      setViewsLevel(currentLevel);
    });

    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return (
    <>
      {viewsLevel > 3 ? (
        <Navigate to="/messages" />
      ) : (
        <>
        <ErrorBoundary
          FallbackComponent={ErrorBoundaryFallback}
          onError={ErrorBoundaryHandler}
        >
          <Header />
        </ErrorBoundary>
          <PageContainer>
            <ErrorBoundary
              FallbackComponent={ErrorBoundaryFallback}
              onError={ErrorBoundaryHandler}
            >
              <Nav currentStep="users" />
            </ErrorBoundary>
            <Body>
              <UserManagementContainer>
                {/*<UsersStats />*/}
                <ErrorBoundary
                  FallbackComponent={ErrorBoundaryFallback}
                  onError={ErrorBoundaryHandler}
                >
                  <Users data={usersData} />
                </ErrorBoundary>
              </UserManagementContainer>
            </Body>
          </PageContainer>
        </>
      )}
    </>
  );
};

export default UserManagement;
